interface GetSupportMailHrefParams {
  email: string;
  subject: string;
  body: string;
}

export const getSupportMailHref = ({
  email,
  subject,
  body,
}: GetSupportMailHrefParams) =>
  `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
